import type { ClientLimitsStatusResponse } from "@/api/limits";

export const CALL_BLOCKED_TOOLTIP_KEY = "limits.callBlockedTooltip";

const CALL_BLOCKING_LIMIT_KEYS = [
  "max_conversations",
  "max_speaking_time",
  "max_time_trail_days",
] as const;

export function isCallBlockedByLimitsStatus(
  statusData?: ClientLimitsStatusResponse | null,
): boolean {
  if (!statusData) return false;

  const usage = statusData.usage ?? {};
  const exceeded = new Set(statusData.exceeded ?? []);

  return CALL_BLOCKING_LIMIT_KEYS.some(
    (key) => exceeded.has(key) || usage[key]?.exceeded === true,
  );
}
